import { render, staticRenderFns } from "./MenuFactures.vue?vue&type=template&id=16c34320&scoped=true&"
import script from "./MenuFactures.vue?vue&type=script&lang=js&"
export * from "./MenuFactures.vue?vue&type=script&lang=js&"
import style0 from "./MenuFactures.vue?vue&type=style&index=0&id=16c34320&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c34320",
  null
  
)

export default component.exports